import { sessionStorageGet } from "@/utils/sessionStorage";
import { isConfigFlagTruthy } from "@/utils/configFlag";

/**
 * `window.rechnerCustomConfig.broker_cta_hold` — disable booking/quote CTAs until
 * at least one broker/pool signal is present (store or session).
 */
export function isBrokerCtaHoldConfigEnabled(): boolean {
  if (typeof window === "undefined") return false;
  const cfg = window.rechnerCustomConfig;
  if (!cfg) return false;
  return (
    isConfigFlagTruthy(cfg.broker_cta_hold) ||
    isConfigFlagTruthy(cfg.hold_booking_cta_until_broker)
  );
}

/** When true, booking/quote CTAs stay disabled until broker/pool data is present. */
export function isBrokerCtaHoldActiveFromInputs(): boolean {
  return isBrokerCtaHoldConfigEnabled();
}

function nonEmptyTrimmed(s: string | false | null | undefined): boolean {
  return typeof s === "string" && s.trim() !== "";
}

/** Session keys mirror `src/utils/brokerUrlQuery.ts` / `addFilterToQuery`. */
const SESSION_KEYS = [
  "broker_phone",
  "broker_name",
  "broker_company",
  "broker_email",
  "pool_email",
  "pool_name",
  "broker_id",
  "broker_sub_id",
] as const;

export type BrokerCtaHoldStoreSlice = {
  brokerPhone: string;
  brokerName: string;
  brokerCompany: string;
  brokerEmail: string;
  poolEmail: string;
  poolName: string;
  brokerId: string;
  brokerSubId: string;
};

/** True if any of the broker/pool signals is present (store or session). */
export function hasAnyBrokerCtaSignal(store: BrokerCtaHoldStoreSlice): boolean {
  const fromStore =
    nonEmptyTrimmed(store.brokerPhone) ||
    nonEmptyTrimmed(store.brokerName) ||
    nonEmptyTrimmed(store.brokerCompany) ||
    nonEmptyTrimmed(store.brokerEmail) ||
    nonEmptyTrimmed(store.poolEmail) ||
    nonEmptyTrimmed(store.poolName) ||
    nonEmptyTrimmed(store.brokerId) ||
    nonEmptyTrimmed(store.brokerSubId);

  if (fromStore) return true;

  for (const key of SESSION_KEYS) {
    const v = sessionStorageGet(key);
    if (nonEmptyTrimmed(v)) return true;
  }
  return false;
}
